<script setup lang="ts">
interface ChipProps {
  label?: string
}

defineProps<ChipProps>()
</script>

<template>
  <Text
    v-if="label"
    class="chip typo-sans-1 px-1.5 py-1 rounded uppercase"
    :text="label"
  />
</template>

<style scoped>
.chip {
  background-color: var(--color-scheme-foreground, var(--colors-linen));
  color: var(--color-scheme-background, var(--colors-sage));
}
</style>
